export default class {
    constructor(
    ) {
        this.username = arguments[0];
        this.password = arguments[1];
    };
};